export function getHomePageNavbarState(input: {
  isAuthenticated: boolean;
  loading: boolean;
  profileLoading: boolean;
}): { shouldHideNavbar: boolean; showNonLoggedNavbar: boolean } {
  return {
    shouldHideNavbar: input.loading || (input.isAuthenticated && input.profileLoading),
    showNonLoggedNavbar: !input.loading && !input.isAuthenticated,
  };
}
